export const titleHoldersWrapperStyles = {
  display: 'flex',
  flexWrap: 'wrap',
};

export const titleHolderPersonStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  padding: '8px 16px 8px 0px',
  minWidth: 120,
  maxWidth: 'fit-content',
  cursor: 'pointer',
  '& [data-is-field-changed="true"]': {
    color: ({ palette }) => palette.primary.main,
  },
  '&:hover .delete-title-holder-button': {
    opacity: 1,
  },
};
